import { titlecase } from 'helpers/sanitize.helper';

export const getLabelFromSectionType = (sectionType: string) => {
    if (sectionType) {
        const [fieldName] = sectionType.split('--');
        return titlecase(fieldName.replace(/_/g, ' ')) ?? '';
    }
    return '';
};
